import React from "react";
import { ListItemText as MUIListItemText, Typography } from "@mui/material";

const ListItemText = ({ item }) => {
  // console.log("Item:", item);
  const title = (
    <Typography xs={12} variant="body2" component="span">
      <b>Ofr Code: </b> {item.ofrCode}
    </Typography>
  );
  // const secondary = (
  //   <Typography xs={12} variant="body2" component="span">
  //     <b>Voucher type: </b> {item.voucherType}
  //   </Typography>
  // );

  return (
    <MUIListItemText
      primary={title}
      // secondary={secondary}
    />
  );
};

export default ListItemText;